import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import BalanceSpender from "@/common/customer-balances/BalanceSpender";

const { Customer } = Mobi2Go;

const CustomerBalances = ({ ViewComponent, rebates }) => {
    const [balances, setBalances] = useState([]);

    useEffect(() => {

        // We shouldn't update balances if the component gets unmounted before our async completes.
        let shouldSetBalances = true;

        const fetchCustomerBalances = async () => {
            try {
                const updatedBalances = await Customer.fetchBalances();

                if (shouldSetBalances) {
                    setBalances(updatedBalances);
                }
            } catch (err) {
                throw err;
            }
        };

        fetchCustomerBalances()
            .catch(err => console.log(err))
        ;

        Customer.bind({
            logIn: fetchCustomerBalances,
            updateBalances: fetchCustomerBalances
        });

        return () => {
            shouldSetBalances = false;

            Customer.unbind({
                logIn: fetchCustomerBalances,
                updateBalances: fetchCustomerBalances
            });
        };
    }, []);

    const formatBalanceName = (name, index) => {
        return `${name.toLowerCase().replaceAll(' ', '-')}-${index}`;
    }

    return (
        <>
            {balances && balances.map((balance, index) => {
                let rebate = null;

                if (rebates && rebates.length) {
                    [rebate] = rebates.filter(
                        rebate => _.isEqual(rebate.source_balance_reference, balance.reference)
                    );
                }

                if (ViewComponent === BalanceSpender && balance.amount === 0 && !rebate?.is_claimed) {
                    return null;
                }

                return (
                    <ViewComponent
                        key={JSON.stringify(balance.reference)}
                        balance={balance}
                        currentRebate={rebate ?? null}
                        formattedBalanceName={formatBalanceName(balance.name, index)}
                    />
                );
            })}
        </>
    );
};

CustomerBalances.propTypes = {
    ViewComponent: PropTypes.elementType.isRequired,
    rebates: PropTypes.array,
};

export default CustomerBalances;
